import React from "react";
import { LuMoon, LuSun } from "react-icons/lu";
import { useThemeMode } from "../../Context/ThemeContext";
import "../../Styles/ThemeToggle.css";

/* --------------------------------------------------------------------------
   ThemeToggle — day / night switch. The thumb carries the icon: a sun on the
   left for light, sliding right and turning into a moon for dark. Until the
   user flips it, the app follows the OS theme, so the thumb starts on
   whichever side the system is on; the first click saves an explicit choice.
   Lives in the top bar only: the auth pages have no switch and just follow the
   saved choice, or the OS theme when nothing is saved.
   -------------------------------------------------------------------------- */
function ThemeToggle() {
  const { resolvedMode, setMode } = useThemeMode();
  const isDark = resolvedMode === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label="Dark theme"
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      className="hc-theme-switch"
      onClick={() => setMode(isDark ? "light" : "dark")}
    >
      <span className="hc-theme-switch-stars" aria-hidden="true" />
      <span className="hc-theme-switch-thumb" aria-hidden="true">
        <LuSun className="hc-theme-switch-sun" size={14} strokeWidth={2.75} />
        <LuMoon className="hc-theme-switch-moon" size={13} strokeWidth={2.75} />
      </span>
    </button>
  );
}

export default ThemeToggle;
